// extracted by mini-css-extract-plugin
export default {"fields":"AddDocument_fields__xzjiw","btnsContainer":"AddDocument_btnsContainer__OVNVE","hasDueDate":"AddDocument_hasDueDate__LkpUs"};